var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('validation-observer',{ref:"form",scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleSubmit = ref.handleSubmit;
return [(_vm.initialized)?_c('form',[_vm._t("default",null,null,{
        loading: _vm.loading,
        loadingConfig: _vm.loadingConfig,
        saving: _vm.saving,
        fields: _vm.fields,
        rawModel: _vm.rawModel,
        errorsObject: _vm.errorsObject,
        disableTag: _vm.disableTag,
        disabled: _vm.disabled,
        groupByTabs: _vm.groupByTabs,
        tabs: _vm.tabs,
        lazyTabs: _vm.lazyTabs,
        methods: {
          restartState: _vm.restartState,
          getFieldsByTag: _vm.getFieldsByTag,
          getFieldsWithAllTags: _vm.getFieldsWithAllTags,
          getFieldsWithAnyTag: _vm.getFieldsWithAnyTag,
          getFieldsWithoutTags: _vm.getFieldsWithoutTags,
          handleSubmit: handleSubmit,
        },
      })],2):_vm._e()]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }